import React		from 'react'
import classNames	from 'classnames'

const SafetyIndexMeter = ({ index }) =>
	<div className="meter">
		{[1, 2, 3, 4, 5].map(grad => {

			const classes = classNames(
				`meter__grad meter__grad--${grad}`, {
					'meter__grad--active': grad == index
				}
			)

			return <div className={classes}>{grad}</div>
		})}
		<div className="meter__score">{index}/5</div>
	</div>

export default SafetyIndexMeter



// WEBPACK FOOTER //
// ./src/js/offer/SafetyIndexScore.js